<template>
  <div class="layout">
    <headerCell :bgColor="bgColor" :fontColor="fontColor"></headerCell>
    <div class="wrap">
      <logoCell></logoCell>
    </div>
    <footerCell></footerCell>
  </div>
</template>

<script>
import headerCell from '../../components/header/index';
import footerCell from '../../components/footer/index';
import logoCell from '../../components/logo/index';
export default{
  data(){
    return{
      bgColor:'rgba(255,255,255,1)',
      fontColor:'#000'
    }
  },
  components:{
    headerCell,
    footerCell,
    logoCell
  },
}
</script>

<style lang="less" scoped>

</style>